import { RequestsWorkspace } from '@/components/requests/requests-workspace'

export function OperationsRequests() {
  return <RequestsWorkspace />
}
